app.service('productTabSpecification', function (productCardConfig, productWarranty) {
	let $expandSpecificationBtn, $specificationExpandableArea, $basicTechDetails, $fullTechDetails, $warrantiesLink;
	let config, isSectionExpanded;

	function init() {
		config = productCardConfig.getData();
		setElements();
		setEvents();
	}

	function setElements() {
		$specificationExpandableArea = $('#specification-expandable-area');
		$expandSpecificationBtn = $('#expand-specification');
		$basicTechDetails = $('#basic-tech-details');
		$fullTechDetails = $('#full-tech-details');
		isSectionExpanded = false;
		$warrantiesLink = $('.js-warranty-scroll');
	}

	function setEvents() {
		$expandSpecificationBtn.click(toggleSpecification);
		$warrantiesLink.on("click", openWarrantyModal);

		$specificationExpandableArea
			.on('click', '.js-tech-details td:first-child a', function () {
				UA.interaction('KP - Opis', 'Słownik', 'Cecha - ' + $.trim($(this).text()) + ' - ' + config.groupName);
			})
			.on('click', '.js-tech-details td:last-child a', function () {
				UA.interaction('KP - Opis', 'Słownik', 'Wartość - ' + $.trim($(this).text()) + ' - ' + config.groupName);
			})
			.on('click', '#find-similar-products', function () {
				UA.pageInteraction('Opis', 'Znajdź podobne produkty');
			});
	}

	function openWarrantyModal() {
		productWarranty.showModal();
	}

	function toggleSpecification() {
		$(this).blur();
		$specificationExpandableArea.toggleClass('full-specification small-specification');
		if(isSectionExpanded) {
			isSectionExpanded = false;
			$expandSpecificationBtn.removeClass('open');
			$basicTechDetails.show();

			$.scrollTo('[data-section-id=specyfikacja]');
		} else {
			isSectionExpanded = true;
			$expandSpecificationBtn.addClass('open');
			if($fullTechDetails.length) {
				$fullTechDetails.show();
				$basicTechDetails.hide();
			}
		}
	}

	return {
		init
	};
});